<div class="w100" >
    <div *ngIf="info" [innerHTML]="info"></div>
</div>